import React from 'react';
import { MapPin, Phone, Clock, AlertCircle } from 'lucide-react';
export function ServiceArea() {
  const locations = [{
    name: 'Howell Auto Glass Service Center',
    address: '222 W Grand River Ave, Howell, MI 48843',
    phone: '517-545-7772',
    desc: 'Main showroom and auto glass service center',
    featured: true
  }, {
    name: 'Ann Arbor Satellite Office',
    address: '2723 South State St, Suite 150, Ann Arbor, MI 48104',
    phone: '734-887-6556',
    desc: ''
  }, {
    name: 'Novi Satellite Office',
    address: '39555 Orchard Hill Place, Suite 600, Novi, MI 48375',
    phone: '248-924-9899',
    desc: ''
  }];
  return <section className="py-16 md:py-20 px-4 sm:px-6 lg:px-8 bg-slate-50 border-y border-slate-200" data-id="element-285">
      <div className="max-w-7xl mx-auto" data-id="element-286">
        <div className="text-center max-w-4xl mx-auto mb-12" data-id="element-287">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-slate-900 mb-5 tracking-tight leading-tight" data-id="element-288">
            <span className="text-brand-red" data-id="element-289">Emergency Auto Glass</span> Near
            Howell, Ann Arbor, Novi &amp; Southeast Michigan
          </h2>
          <p className="text-lg text-slate-600 mb-6" data-id="element-290">
            Kosin's Glass serves drivers across Southeast Michigan, including
            Howell, Ann Arbor, Novi, Brighton, Fenton, Hartland, Fowlerville,
            Northville, Lansing, East Lansing, Grand Blanc, Webberville,
            Williamston, Livonia, Milford, Pinckney, Whitmore Lake, Wixom and
            nearby communities.
          </p>

          <div className="inline-flex items-start sm:items-center gap-2 bg-white text-slate-700 px-4 py-2.5 rounded-lg border border-slate-200 font-medium text-sm shadow-sm text-left" data-id="element-291">
            <AlertCircle className="w-5 h-5 text-brand-red shrink-0 mt-0.5 sm:mt-0" data-id="element-292" />
            <span data-id="element-293">
              For urgent auto glass help, call first to confirm today's
              availability and the safest next step.
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10" data-id="element-294">
          {locations.map((loc, i) => <div key={i} className={`bg-white rounded-xl p-6 border shadow-sm flex flex-col h-full ${loc.featured ? 'border-brand-red/40 ring-1 ring-brand-red/20' : 'border-slate-200'}`} data-id="element-295">
              {loc.featured && <div className="inline-block bg-brand-red text-white px-2.5 py-1 text-xs font-bold uppercase tracking-wider rounded mb-3 w-fit" data-id="element-296">
                  Main Location
                </div>}
              <h3 className="text-lg font-bold text-slate-900 mb-4" data-id="element-297">
                {loc.name}
              </h3>
              <div className="space-y-3 flex-grow" data-id="element-298">
                <div className="flex items-start gap-2.5" data-id="element-299">
                  <MapPin className="w-5 h-5 text-brand-red shrink-0 mt-0.5" data-id="element-300" />
                  <span className="text-slate-600" data-id="element-301">{loc.address}</span>
                </div>
                <div className="flex items-start gap-2.5" data-id="element-302">
                  <Phone className="w-5 h-5 text-brand-red shrink-0 mt-0.5" data-id="element-303" />
                  <a href={`tel:${loc.phone}`} className="text-slate-900 font-bold hover:text-brand-red transition-colors" data-id="element-304">
                    {loc.phone}
                  </a>
                </div>
                {loc.desc && <p className="text-sm text-slate-500 mt-4 pt-4 border-t border-slate-100" data-id="element-305">
                    {loc.desc}
                  </p>}
              </div>
            </div>)}
        </div>

        <div className="bg-white rounded-xl p-6 sm:p-8 text-center max-w-2xl mx-auto border border-slate-200 shadow-sm" data-id="element-306">
          <div className="flex items-center justify-center gap-2 mb-4" data-id="element-307">
            <Clock className="w-5 h-5 text-brand-red" data-id="element-308" />
            <h3 className="text-lg font-bold text-slate-900" data-id="element-309">Hours</h3>
          </div>
          <div className="space-y-1.5 text-slate-600" data-id="element-310">
            <p data-id="element-311">
              <span className="font-semibold text-slate-900" data-id="element-312">
                Monday–Friday:
              </span>{' '}
              8:00 a.m. to 5:00 p.m.
            </p>
            <p data-id="element-313">
              <span className="font-semibold text-slate-900" data-id="element-314">Saturday:</span>{' '}
              9:00 a.m. to 3:00 p.m.
            </p>
            <p data-id="element-315">
              <span className="font-semibold text-slate-900" data-id="element-316">Sunday:</span>{' '}
              Closed
            </p>
          </div>
        </div>
      </div>
    </section>;
}